import React, { Component } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Badge, UncontrolledDropdown,Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem, Button, Col, Row, PopoverBody, Popover } from 'reactstrap';
import PropTypes from 'prop-types';

import { AppAsideToggler, AppNavbarBrand, AppSidebarToggler } from '@coreui/react';
import logo from '../../assets/img/brand/logo.svg'
import sygnet from '../../assets/img/brand/sygnet.svg'
import NameComponent from '../../Components/NameComponent';
import {connect} from 'react-redux'
import { CheckLogin_ACTION, Logout_ACTION } from '../../Actions/AuthorizationActions';
import DropDownComponent from '../../Components/DropDownComponent';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import ModalComponent from '../../Components/ModalComponent';
import { Routes } from '../../Services/API';
import { GetListAttempt_ACTION, GetMultipleListAttempt_ACTION } from '../../Actions/LogisticActions';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import ModalFooter from 'reactstrap/lib/ModalFooter';
import ModalBody from 'reactstrap/lib/ModalBody';
import { responsiveFontSize, responsiveHeight, responsiveWidth, timeSince, UpdateDatapool, WEBSITE_URL } from '../../Services/Utilities';
import { Mention, MentionsInput } from 'react-mentions';

const propTypes = {
  children: PropTypes.node,
};
var LogoImage = require('../../Sources/Heat_quiz_logo.png')

const defaultProps = {};
var timer
class DefaultHeader extends Component {
  constructor(props){
    super(props)

    this.state = {
      rolesIndex:0,
      HoverLogout: false,
      DPDropDownOpen: false,
      SelectedDP: {Nickname:'Select Datapool', Id: -1}
    }
    this.closeDialog = this.closeDialog.bind(this);

}



 componentDidMount(){
   this.props.GetDataPools()

   if(this.props.token){
    timer = setTimeout(() => {
      this.props.GetNotificationsCount()
  }, 1500);
   }
 }

 UNSAFE_componentWillReceiveProps(nextProps){
  console.log(nextProps)

  if(nextProps.DPs && nextProps.DPs.length && nextProps.DPs.map(dp => dp.Id).includes(this.props.data_pool_id) && !this.props.roles.includes("student")){
    console.log("Update datapool")

    let dp = nextProps.DPs.filter(dp => dp.Id == nextProps.data_pool_id)[0]

    console.log(dp)

    this.setState({
      SelectedDP: dp
    })
  }
  else{

  }
 }



 closeDialog() {
  this.setState({
    ShowDataPools:false
  })
  
}

  render() {
    console.log(this)
    console.log(this.state.HoverLogout)
    // eslint-disable-next-line
    const { children, ...attributes } = this.props;

    return (
      <React.Fragment>
        
        <AppSidebarToggler className="d-lg-none" display="md" mobile />
        <div style = {{flexDirection:'row', display:'flex', width:'100%', alignContent:'center', alignItems:'center'}}>
          <div style = {{width: '20%'}}

          >
          <AppNavbarBrand
            full={{ src: LogoImage,
             height: responsiveHeight(2),objectFit:'contain',  alt: 'Heat Quiz' }}
            minimized={{ src: LogoImage,
             height: responsiveHeight(2), alt: 'Heat Quiz',objectFit:'contain' }}
          />
          </div>
          <div 
          style = {{width: '60%', flexDirection:'row-reverse', display:'flex', alignItems:'center', alignContent:'center'}}>
          
                <Dropdown isOpen={this.state.DPDropDownOpen} toggle={() => {
                           this.setState(prev => ({
                             DPDropDownOpen: !this.state.DPDropDownOpen
                           }))
                        }}>
                          <DropdownToggle caret
                          className ="text-muted"
                         style = {{width: responsiveWidth(15), backgroundColor:'white', fontSize: responsiveFontSize(0.75),
                         textOverflow:'ellipsis', overflow:'hidden', whiteSpace:'nowrap', textAlign:'left'}}
                          onClick={() => {
                            this.setState(prev => ({
                              DPDropDownOpen: !this.state.DPDropDownOpen
                            }))
                          }}
                          >
                            {this.state.SelectedDP.NickName}
                          </DropdownToggle>
                          <DropdownMenu>
                            {(this.props.DPs ||[]).map((d,i) => (
                              <DropdownItem 
                              style = {{width: responsiveWidth(15), backgroundColor:'white', fontSize: responsiveFontSize(0.75),
                              textOverflow:'ellipsis', overflow:'hidden', whiteSpace:'nowrap'}}
                               key = {i} onClick={() => {
                                this.setState(prev => ({
                                  SelectedDP:d,
                                  DPDropDownOpen: !prev.DPDropDownOpen
                                }))

                                UpdateDatapool(d)

                                this.props.CheckLogin()
                              }}>{d.NickName}</DropdownItem >
                              
                            ))}
                          </DropdownMenu>
                        </Dropdown>
                       
          
          </div>
          <div 
          onClick = {() => {
            this.setState({
              ShowUserList: !this.state.ShowUserList
            })
          }}
          id="User_List"
          className ="bg-light square border border-secondary"
          style = {{width: '18.5%', marginLeft:'1%', height: 'auto', cursor:'pointer',
     
          flexDirection:'row', display:'flex', borderRadius:responsiveFontSize(0.25), verticalAlign:'center',alignItems:'center', alignContent:'center',}}
          
          >
            <h6 
            
            style = {{textAlign:'left', fontSize: responsiveFontSize(0.8), marginTop:responsiveHeight(0.85), 
                              textOverflow:'ellipsis', overflow:'hidden', whiteSpace:'nowrap', width:'78%', marginLeft:'4%'}}>
                {this.props.name}
              </h6>
             { this.props.NotificationsCount && this.props.NotificationsCount.Count ? <h6 style = {{textAlign:'center', fontSize: responsiveFontSize(0.8), marginTop:responsiveHeight(0.85), 
                              textOverflow:'ellipsis', overflow:'hidden', whiteSpace:'nowrap', width:'16%', marginLeft:'1%', marginRight:'1%'}}>
                <strong className="text-muted">🔔</strong>
            <span class="badge rounded-pill badge-notification bg-primary">{this.props.NotificationsCount.Count}</span>
        </h6> : <div/>}
              
              <Popover 
                    trigger = "focus"
                    placement="bottom" isOpen={this.state.ShowUserList} 
                    target={"User_List"} toggle={() => {
                        this.setState({
                          ShowUserList: !this.state.ShowUserList
                        })
                    }}
                    >
                        <PopoverBody>
                        <div style = {{width: responsiveWidth(12)}}>
                        <div className="square border-bottom">
                        <h6 style = {{fontSize: responsiveFontSize(0.8), cursor:'pointer', marginTop: responsiveHeight(0.25)}} onClick = {() => {
                          this.props.Logout()
                        }}>
                                                  <i class="fa fa-sign-out text-muted" aria-hidden="true" style = {{marginRight: responsiveWidth(0.5)}}
                                                  ></i>

  Logout <i className="text-primary" style = {{fontSize: responsiveFontSize(0.75), marginLeft: responsiveWidth(0.5)}}>@{this.props.username}</i>
                        </h6>
                        </div>
                        
                        { this.props.NotificationsCount && this.props.NotificationsCount.Count ?
                        <div className="square border-bottom" style = {{marginTop:responsiveHeight(0.25)}}>
                          <h6 className="text-muted" style = {{marginBottom: responsiveHeight(0.4), fontSize: responsiveFontSize(0.5), marginLeft:'1%'}}>New notifications</h6>
                          <div style = {{height: responsiveHeight(14), overflowY:'scroll'}}>

                          {this.props.NotificationsCount.Comments.map((c, ci) => (
                            <div 
                            className="square border border-light"
                            key = {ci}
                            onClick = {() => {
                              this.props.RegisterSeenNotification(c.CommentSection.Id)
                              
                              let URL = WEBSITE_URL + '/Questions/QuestionViewEdit/' + c.CommentSection.Question.Id + '/'+ c.CommentSection.Question.Type
                              window.open(URL)
                            }}
                            style = {{cursor:'pointer', flexDirection:'column', display:'flex', width:'99%', marginLeft:'1%',
                             marginBottom: responsiveHeight(0.5)}}>
                            <div style = {{flexDirection:'column', display:'flex', alignContent:'flex-start', alignItems:'flex-start'}}>
                                <h6 style ={{fontSize: responsiveFontSize(0.5), textAlign:'left'}}>
                                    <strong>{c.AddedByName}</strong>
                                </h6>
                                <h6 className = "text-muted" style ={{fontSize: responsiveFontSize(0.5), textAlign:'left',  marginTop: -responsiveHeight(0.8)}}>
                                    {` ${timeSince(c.DateCreated)}`} ago
                                </h6>
                            </div>
                            <div style = {{flexDirection:'row', display:'flex', alignContent:'flex-start', alignItems:'flex-start',  marginTop: -responsiveHeight(0.25)}}>
                                <h6 style ={{fontSize: responsiveFontSize(0.45), textAlign:'left', width:'50%'}}>
                                    {c.CommentSection.Question.Code}
                                </h6>
                                <img 
                              src = {c.CommentSection.Question.Base_ImageURL}
                              className = "border"
                              style = {{objectFit:'contain', height: responsiveHeight(8), width:'45%', margin: responsiveFontSize(0.1)}}
                              />
                            </div>
                        <MentionsInput
                            value={c.Text}
                            disabled
                            style={{control: {
                                backgroundColor: 'white',
                                fontSize: responsiveFontSize(0.5),
                                border: '0px solid silver',
                            },
                            '&multiLine': {
                               
                                input: {
                                  padding: 1,
                                  border: '0px solid silver',
                                },
                              },
                              '&singleLine': {
                                
                                input: {
                                  padding: 1,
                                  border: '0px inset',
                                },
                              }}}>

                            <Mention
                            data={([])} 
                            style = {{backgroundColor: "#cee4e5"}}
                            />
                        </MentionsInput>
                        {c.NumberOfComments > 1 ? 
                        <div style = {{marginTop: responsiveHeight(0.5)}}>
                                <h6
                                className="text-muted"
                                style ={{fontSize: responsiveFontSize(0.45), textAlign:'left', width:'50%'}}>
                                   <strong>+</strong>{c.NumberOfComments - 1} older comments
                                </h6>
                        </div> : <div/>}
                    </div>
                          ))}
                        </div>
                        </div> : <div/>}
                        </div>
                        </PopoverBody>
                    </Popover> 
                    
          </div>
        </div>
         
           
              
      </React.Fragment>
    );
  }
  
}


const DP_SEARCHING_PARAMETER = 'IsDPSearching'
const DP_DATA_PARAMETER = 'DPs'
const DP_GET_ERROR_PARAMETER = 'DPGetError'

const NOTIFICATIONS_COUNT_DATA = 'NOTIFICATIONS_COUNT_DATA'
const NOTIFICATIONS_COUNT_ERROR = 'NOTIFICATIONS_COUNT_ERROR'
const NOTIFICATIONS_COUNT_PARAMETER = 'NOTIFICATIONS_COUNT_PARAMETER'

function MapStateToProps(state) {
  console.log(state)
  return {
    username: state.Authorization.username,
    name: state.Authorization.name,
    roles: state.Authorization.roles,
    token: state.Authorization.token,
    data_pool_name: state.Authorization.data_pool_name,
    data_pool_id: state.Authorization.data_pool_id,

    DPs:state.Query[DP_DATA_PARAMETER],
    IsSearching: state.Query[DP_SEARCHING_PARAMETER],

    GetError: state.Query[DP_GET_ERROR_PARAMETER],

    NotificationsCount:state.Query[NOTIFICATIONS_COUNT_DATA],
    IsNotificationsCountSearching: state.Query[NOTIFICATIONS_COUNT_PARAMETER],
    GetNotificationsCountError: state.Query[NOTIFICATIONS_COUNT_ERROR],
  }
}

const MapDispatchToProps = (dispatch) => {
  return {
    Logout : () => {dispatch(Logout_ACTION())},
    GetDataPools: () => {dispatch(GetListAttempt_ACTION(
      {
        SearchParameter: DP_SEARCHING_PARAMETER,
        DataParameter: DP_DATA_PARAMETER,
        GetErrorParameter: DP_GET_ERROR_PARAMETER,
  
        Path: Routes.GetDataPools,
  
        [DP_SEARCHING_PARAMETER]: true,
        [DP_DATA_PARAMETER]: [],
        [DP_GET_ERROR_PARAMETER]: '',
    }))},
    CheckLogin: () => {dispatch(CheckLogin_ACTION())},

  GetNotificationsCount: () => {dispatch(GetListAttempt_ACTION({
          SearchParameter: NOTIFICATIONS_COUNT_PARAMETER,
          DataParameter: NOTIFICATIONS_COUNT_DATA,
          GetErrorParameter: NOTIFICATIONS_COUNT_ERROR,

          Path: Routes.GetUnseenCommentsNumber,
  
          [NOTIFICATIONS_COUNT_PARAMETER]: true,
          [NOTIFICATIONS_COUNT_DATA]: [],
          [NOTIFICATIONS_COUNT_ERROR]: '',
      }))},
      RegisterSeenNotification: (Value) => {dispatch(GetListAttempt_ACTION({
        Path: Routes.RegisterSeenNotification,
        Value: Value
      }))},


  }
}

export default connect(MapStateToProps, MapDispatchToProps)(DefaultHeader)